import { put, takeLatest, fork, call, delay } from 'redux-saga/effects';
import { WebConfig } from 'config';
import * as actionTypes from '../actionTypes';
import {
    loadTodoSuccess,
    loadTodoError,
    getSublocationDetail
} from "store/actions";

import { ClientInstance } from 'utils/axios-instance';

const API_POINT_URL = WebConfig.serviceUrls.RestApi;
const AREA_NAMES_POINT_URL = WebConfig.ApiUrls.configurations.areanames;

// Add Area Name
export function* addAreaName(payload) {
    const { payload: data } = payload;

    const response = yield call(() => {
        return ClientInstance
            .post(`${API_POINT_URL}${AREA_NAMES_POINT_URL}`, data)
            .then(response => {
                return response;
            })
    });

    if (response && response.data.status === 200) {
        console.log("Area added successfully:", response.data.response.detail);
        
        // Re-fetch area names to update the list (instead of full sublocation refresh)
        if (data.area) {
            yield delay(300);
            yield getAreaNames({
                type: actionTypes.GetAreaNames,
                payload: { areaId: data.area }
            });
        }
    }

    if (response && response.data && response.data.status !== 200 && response.data.status !== 401) {
        yield put(loadTodoError(response.data.message.detail));
    }
}

// Update Area Name
export function* updateAreaName(payload) {
    const { payload: { areaNameId, data, sublocationId } } = payload;
    const response = yield call(() => {
        return ClientInstance
            .put(`${API_POINT_URL}${AREA_NAMES_POINT_URL}${areaNameId}/`, data)
            .then(response => {
                return response;
            })
    });

    if (response && response.data.status === 200) {
        console.log("Area updated successfully:", response.data.response.detail);
        
        // Re-fetch area names to update the list (instead of full sublocation refresh)
        if (data.area) {
            yield delay(300);
            yield getAreaNames({
                type: actionTypes.GetAreaNames,
                payload: { areaId: data.area }
            });
        }
    }

    if (response && response.data && response.data.status !== 200 && response.data.status !== 401) {
        yield put(loadTodoError(response.data.message.detail));
    }
}



// Get Area Names List
export function* getAreaNames(payload) {
    const { payload: { areaId } } = payload;
    const response = yield call(() => {
        return ClientInstance
            .get(`${API_POINT_URL}${AREA_NAMES_POINT_URL}?area=${areaId}`)
            .then(response => {
                return response;
            })
    });

    if (response && response.data.status === 200) {
        // Dispatch success action with area names data
        yield put({
            type: actionTypes.GetAreaNamesSuccess,
 payload: {
                areaId: areaId,
                data: response.data.response.results || []
            }
        });
    }

    if (response && response.data && response.data.status !== 200) {
        yield put(loadTodoError(response.data.message.detail));
        yield put({
            type: actionTypes.GetAreaNamesFailure,
            payload: response.data.message.detail
        });
    }
}

// Watcher Functions
function* watchAddAreaName() {
    yield takeLatest(actionTypes.AddAreaName, addAreaName)
}

function* watchUpdateAreaName() {
    yield takeLatest(actionTypes.UpdateAreaName, updateAreaName)
}



function* watchGetAreaNames() {
    yield takeLatest(actionTypes.GetAreaNames, getAreaNames)
}

// Export array of forked watchers
export const areaSaga = [
    fork(watchAddAreaName),
    fork(watchUpdateAreaName),
    fork(watchGetAreaNames)
]